import { PathOptions } from "leaflet";

export const areas_prioritarias_conservacao_mata_atlantica = (
  feature: any
): PathOptions => {
  return {
    fillColor: "#3aa848ff",
    color: "#41e44fff",
    weight: 0.5,
    fillOpacity: 0.5,
  };
};
